var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteForever(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.889,
    height: 14,
    viewBox: "0 0 10.889 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M8.278,16.944A1.56,1.56,0,0,0,9.833,18.5h6.222a1.56,1.56,0,0,0,1.556-1.556V7.611H8.278Zm1.913-5.538,1.1-1.1,1.657,1.649,1.649-1.649,1.1,1.1-1.649,1.649L15.69,14.7l-1.1,1.1-1.649-1.649L11.3,15.8l-1.1-1.1,1.649-1.649Zm5.476-6.129L14.889,4.5H11l-.778.778H7.5V6.833H18.389V5.278Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#0d70d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteForever);
export default __webpack_public_path__ + "static/media/Delete-Forever.1f03e0c78b965904df952861386061cd.svg";
export { ForwardRef as ReactComponent };